import React, { Component }  from 'react'
import { Icon, Modal, Button } from 'semantic-ui-react'
import FileInput from '../../components/FileInput/FileInput'

class TeachersReadCSV extends Component {
  render() {
    return (
      <Modal
        trigger={
          <Button icon labelPosition='left' color='green'> <Icon name='upload' />
          Import Teachers
          </Button>
        }
        closeIcon
        >
        <Modal.Header>Import Teachers</Modal.Header>
        <Modal.Content>
            <FileInput
              handleFileChange={this.props.handleFileChange}
              className='teachers-file-input'
              error={false}
            />
        </Modal.Content>
        <Modal.Actions>
          <Button color='green' onClick={this.props.handleDataSave}>
            <Icon name='checkmark' /> Save
          </Button>
        </Modal.Actions>
      </Modal>
    )
  }
};

export default TeachersReadCSV;
